export default __webpack_public_path__ + "static/media/metaMaskGif.bffc86f7.gif";